export default __webpack_public_path__ + "static/media/ig_profile_visits.eca5d4e6.png";